// src/data/morseMessages.js

export const MORSE_MESSAGES = [
  {
    text: "You can't win if you don't play",
    author: "Lottery Proverb",
  },
  // 将来追加
];
